import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';

import { trapActivityLineChartOptions } from './chartOptions';

import { useGetMiceToTrapAmountChartState } from 'hooks/Analitics/MCTCharts/4_miceToTrapAmountLineChart/useGetMiceToTrapAmountChartState';
import ChartTitle from 'pages/ObjectAnalitics/ChartTitle/ChartTitle';
import { TrapType } from 'components/AnalyticsPage/TrapType';
import { ObjectTraps } from 'api/analitics/types';
import { MediaBreakpoints } from 'hooks/Screen/useScreenSize';

interface ChartProps {
  slug: string;
  type: TrapType;
  objectTraps: ObjectTraps;
}

const MiceToTrapActivityLineChart: React.FC<ChartProps> = ({ slug, type, objectTraps }) => {
  const [trapType, setTrapType] = useState<TrapType>(type);
  const { period, startDate, endDate, showCustom, chartData, handlePeriodChange, setStartDate, setEndDate } =
    useGetMiceToTrapAmountChartState({ slug, trapType });
  const { t } = useTranslation();
  const isMobile = useMediaQuery(MediaBreakpoints.mobile);
  const chartOptions = trapActivityLineChartOptions(chartData, t, trapType, isMobile);

  return (
    <div className="card card-height-100 m-0 border border-2 rounded-4 position-relative h-100">
      <div className="card-header rounded-4">
        <ChartTitle
          title={t('ChartsAnalitics.traps_vs_cought_mice_chart.title')}
          period={period}
          handlePeriodChange={handlePeriodChange}
          startDate={startDate}
          setStartDate={setStartDate}
          showCustom={showCustom}
          endDate={endDate}
          setEndDate={setEndDate}
          showSetTrapTypeFilter={
            objectTraps.mct.was_ever_installed && objectTraps.smst.was_ever_installed && type !== TrapType.SRST
          }
          trapType={trapType}
          setTrapType={(value: TrapType) => setTrapType(value)}
        />
      </div>
      <div className="card-body">
        <div className="position-relative">
          <div id="chart">
            <ReactApexChart
              key={trapType}
              options={chartOptions}
              series={chartOptions.series}
              type="area"
              height={400}
            />
          </div>
          <div id="html-dist" />
        </div>
      </div>
    </div>
  );
};

export default MiceToTrapActivityLineChart;
